module.exports = __webpack_public_path__ + "img/haut-und-haarpflege_ZEITGUARD1-hintergurnd.5eeefa3f.jpg";